import {TasksViewAppSettings} from "../../@types"
import {ColumnSettingsConfig} from "../../../../manager/columns/types"
import convertOldSettingsColumnId from "../../manager/columns/functions/settings-column-id-converer"

export default function tasksView_settingConverter_V2ToV3(appSettingsConfig: TasksViewAppSettings) {

    // 1. iterate through each column config and convert its ID to the new format
    _.map(appSettingsConfig.columns, (config: ColumnSettingsConfig) => {
        // somehow, config objects may be empty or missing an 'id' property,
        // so it's important to verify 'id' is present before proceeding
        if (!config.id) {
            return
        }

        config.id = convertOldSettingsColumnId(config.id)
    })

}